<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one item">
        <div class="page">
          <p>专注行业数据服务，专注RFID技术解决方案</p>
        </div>
        <p class="slogan">因为专业我们更卓越</p>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two item">
        <div class="page">
          <p>专注行业数据服务，专注RFID技术解决方案</p>
        </div>
        <p class="slogan">因为专业我们更卓越</p>
      </swiper-slide>
    </swiper>
    <div class="bot">
      <div class="swiper-slide slide-three">
        <div class="page">
          <h3 style="color: #333;">产品服务</h3>
          <p style="color: #333;">Product Service</p>
        </div>
        <ul class="case-item">
          <li v-for="(item, index) in caseList" :key="index" v-lazy:background-image="item.Img">
            <router-link class="text-decoration" :to="{ name: 'casedetails', params: { id: item.id } }">
              <div class="case-item-hover">
                <p class="hover-title">{{ item.Title }}</p>
                <div class="bottom"></div>
                <div class="more">
                  <span>MORE</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="swiper-slide slide-four">
        <div class="page">
          <h3 style="color: #333;">最新资讯</h3>
          <p style="color: #333;">Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news, i) in newsList" :key="i">
            <div :style="'order: ' + (i % 2 == 0 ? 1 : 3)">
              <router-link class="text-decoration" :to="{ name: 'newsdetails', params: { id: news.id } }">
                <div class="item-img" v-lazy:background-image="news.Img"></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: ' + (i % 2 == 0 ? 3 : 1)">
              <h3 style="color: #333;">{{ news.Title }}</h3>
              <p style="color: #333;">{{ news.Content }}</p>
              <span style="color: #333;">{{ news.CreateTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [
        {
          id: 1,
          Img: 'http://www.sdtimo.com/imgs/1-3.jpg',
          Title: '不忘初心担使命，优质服务表扬来',
        },
        {
          id: 2,
          Img: 'http://www.sdtimo.com/imgs/1-4.jpg',
          Title: '全国接种加速，RFID助力新冠疫苗全程追溯！',
        },
        {
          id: 3,
          Img: 'http://www.sdtimo.com/imgs/1-2.jpg',
          Title: '数据中心托管服务',
        },
        {
          id: 4,
          Img: 'http://www.sdtimo.com/imgs/1-5.jpg',
          Title: '数智固定资产管理系统 ',
        },
        {
          id: 5,
          Img: 'http://www.sdtimo.com/imgs/1-1.jpg',
          Title: '低值易耗品管理系统 ',
        },
        {
          id: 6,
          Img: 'http://www.sdtimo.com/imgs/1-1.jpg',
          Title: 'RFID条码应用管理软件  ',
        },
      ],
      newsList: [
        {
          id: 9,
          Img: 'http://www.sdtimo.com/imgs/2-3.jpg',
          Title: '财政部印发《关于盘活行政事业单位国有资产的指导意见》',
          Content: `以习近平新时代中国特色社会主义思想为指导，深入贯彻党的二十大精神，完整准确全面贯彻新发展理念，
          着力推动高质量发展，主动构建新发展格局，加快推进行政事业单位各类国有资产盘活利用，建立健全资产盘活工作机制，
          通过自用共享调剂出租处置等多种方式，提升资产盘活利用效率，为保障行政事业单位履职和事业发展促进经济社会发展提供更加坚实的物质基础`,
          CreateTime: '2023-12-18',
        },
        {
          id: 10,
          Img: 'http://www.sdtimo.com/imgs/2-1.jpg',
          Title: '废旧资产处置可以如此优化',
          Content: `废旧资产的妥善处理，可有效规避事业单位资产流失，但从管理现状来看，多数事业单位对废旧资产处置工作重视程度不高，
          甚至有些单位的资产管理系统并未涵盖废旧资产处置内容。同时，尽管某些事业单位已建立废旧资产处置平台，但处理流程过于繁杂，耗费的人力物力较大，
          管理效率偏低，容易造成资产的流失。所以，针对现有的处置管理问题，积极建设与优化废旧资产处置平台，提升废旧资产处理效率，是一项有益的发的更多的工作。 `,
          CreateTime: '2023-09-27',
        },
        {
          id: 11,
          Img: 'http://www.sdtimo.com/imgs/2-2.jpg',
          Title: `行政事业单位国有资产盘活的措施及对策`,
          Content: `根据指导意见，盘活方式主要包括优化在用资产管理推进资产共享共用加强资产调剂实施公物仓管理开展资产出租或者处置探索资产集中运营管理，
          各单位应当根据待盘活资产和本单位实际情况选择盘活方式，建立一物一案的资产盘活方案 `,
          CreateTime: '2023-07-20',
        },
      ],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "horizontal", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: false, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      },
    };
  },
  created() { },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`)
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    this.loading = false;
    //     })
    //   );
  }
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.item{
  height: 500px;
}
.bot{
  padding: 20px ;
}
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;

    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}

//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;
    transition: background-size 0.3s ease; /* 过渡效果 */

    &:hover {
      background-size: 120% 120%; /* 悬停时放大10% */
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.5);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;

    span {
      color: #fff;
      font-size: 20px;
    }
  }
}

// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(https://img02.e23.cn/31e7c3cc1776866b90056a98d0ccab17.jpg?q=65) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(https://wscdn.ql1d.com/07961790454977082605.jpg) no-repeat center;
  background-size: cover;
}

.slide-three { 
  background-color: #fff;
  // background: url(https://pic.quanjing.com/z9/da/QJ9123732109.jpg?x-oss-process=style/350h) no-repeat center;
  // background-size: cover;
}
.slide-four { 
  background-color: #fff;
  // background: url(https://pic.quanjing.com/z9/da/QJ9123732109.jpg?x-oss-process=style/350h) no-repeat center;
  // background-size: cover;
}

//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }

    .el-divider {
      background-color: #000000;
      height: 3px;

      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #000000;
      }
    }

    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;

      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }

      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }

      h3,
      p,
      span {
        color: #f8f8f8;
      }
    }
  }
}

.order {
  order: -1;
}

.order-img {
  order: 1;
}
</style>